import { substring } from './runesCopy';
export function getTrimString(string, num) {
  return string && string.length > num ? substring(string, 0, num - 3) + '...' : string;
}



// WEBPACK FOOTER //
// ./src/Utils/StringUtils.js